import { toast } from "react-toastify";

import { useMutation } from "@tanstack/react-query";

import { PaymentFormScheme } from "../../../components/Modules/BookingInfo/components/validation.ts";
import { useAuth } from "../../../utils/context/Auth/AuthContext.tsx";
import useFetch from "../../../utils/hooks/useFetch.ts";
import { queryClient } from "../../queryClient.ts";
import { Urls } from "../../urls.ts";

export const useBookingPayment = (id: string) => {
  const { token } = useAuth();
  const fetch = useFetch();

  return useMutation({
    mutationFn: (data: PaymentFormScheme) => {
      const response = fetch(`${Urls.BookingPay}?paymentMethod=${data.paymentMethod}&amount=${data.amount}`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: new Headers({
          "Content-Type": "application/json; charset=utf-8",
        }),
        slug: {
          bookingId: id,
        },
      }, true, token);

      return response;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["booking-id", id] });
      toast.success("Успішно оновлено платіж");
    },
    onError: (error) => {
      toast.error(error?.message || "Error updating booking payment");
    },
  });
};
